import React from 'react'

export default function AgendaComp({color, text, margin, time}) {
    return (
        <div className={"agenda " + (margin?'marginTop' :'')}>
                            <div className="time">
                                {time.map(el => <p>{el}</p> )}
                            </div>
                            <h4 className={"agendaText " + color}>
                                {text}
                            </h4>
        </div>
    )
}
